import {
  ManagedBy,
  PrimaryAction,
  TestCard,
} from "@app/provider/testData/types";
import { PanoramaTestCard } from "./PanoramaTestCard";
import { IntlShape } from "react-intl/src/types";
import { messages } from "@app/provider/testData/messages";

export class SGNIPTTestCard extends PanoramaTestCard {
  protected getPrimaryActionForRedrawNeeded(
    testCard: TestCard
  ): PrimaryAction | undefined {
    // temporarily hide the primary action
    // if (testCard.managedBy == ManagedBy.NATERA) {
    //   return PrimaryAction.SCHEDULE_A_DRAW;
    // }
    return undefined;
  }
}
